export default __webpack_public_path__ + "static/media/spinner.c9a98d3d.gif";